import { REQUEST_FAIL, REQUEST, POST_COMPLETE, POST_OK } from "./constants";
import API from "redux/api/site";
import { receiveFail as authFail } from "redux/authenticate/actions";

export function refresh(data, pager) {
  return dispatch => {
    dispatch(loadStart(data));
    let status;
    return API.create(data, pager)
      .then(response => {
        status = response.status;
        return response.json().then(json => ({
          ok: response.ok,
          status: response.status,
          json
        }));
      })
      .then(({ json, ok, status }) => {
        if (ok) {
          dispatch({ type: POST_OK, payload: json, name: data.name });
        } else if (status === 401 || status === 403) {
          dispatch(authFail({ status }));
        }
        return dispatch({
          type: POST_COMPLETE,
          payload: json,
          name: data.name
        });
      })
      .catch(errors => dispatch(receiveFail({ errors, data, status })));
  };
}

function loadStart({ name }) {
  return {
    type: REQUEST,
    name
  };
}

function receiveFail({ errors, name, status } = {}) {
  return {
    type: REQUEST_FAIL,
    errors,
    name,
    status
  };
}
